<template>
  <div id="header">
    <b-container>
      <b-row class="justify-content-center">
        <b-nav>
          <b-nav-item
            target="_blank"
            href="https://www.facebook.com/LifestyleZindaa/"
          >
            <fa-icon
              :icon="{ prefix: 'fab', iconName: 'facebook-square' }"
              color="#4267b2"
              size="lg"
            />
          </b-nav-item>
          <b-nav-item
            target="_blank"
            href="https://www.youtube.com/channel/UCuPr1JWCETnN1qQWxGiWSEg"
          >
            <fa-icon
              :icon="{ prefix: 'fab', iconName: 'youtube' }"
              color="#ff0000"
              size="lg"
            />
          </b-nav-item>
          <b-nav-item target="_blank" href="https://twitter.com/LifestyleMNN">
            <fa-icon
              :icon="{ prefix: 'fab', iconName: 'twitter' }"
              color="#1da1f2"
              size="lg"
            />
          </b-nav-item>
          <b-nav-item
            target="_blank"
            href="https://www.instagram.com/LifestyleMNZ/"
          >
            <fa-icon
              :icon="{ prefix: 'fab', iconName: 'instagram' }"
              size="lg"
            />
          </b-nav-item>
          <b-nav-item target="_blank" href="https://soundcloud.com/lifestylemn">
            <fa-icon
              :icon="{ prefix: 'fab', iconName: 'soundcloud' }"
              color="#ff5900"
              size="lg"
            />
          </b-nav-item>
        </b-nav>
      </b-row>
      <b-row class="d-none d-md-block">
        <b-col class="header-logo" cols="12">
          <b-link to="/">
            <img src="/static/images/logo.png" alt="Lifestyle" />
          </b-link>
        </b-col>
      </b-row>
      <b-navbar toggleable="md">
        <b-navbar-brand class="d-block d-md-none" href="/">
          <img src="/static/images/logo.png" width="80" alt="Lifestyle" />
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse" />

        <b-collapse is-nav id="nav_collapse" class="justify-content-center">
          <b-navbar-nav>
            <b-nav-item to="/" exact>Эхлэл</b-nav-item>
            <b-nav-item
              :to="'/' + menu.slug"
              v-for="menu in menus"
              :key="menu.id"
              >{{ menu.name }}</b-nav-item
            >
            <b-nav-item href="http://news.zindaa.mn/" target="_blank"
              >Zindaa.mn</b-nav-item
            >
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookSquare,
  faTwitter,
  faYoutube,
  faInstagram,
  faSoundcloud
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faSearch);
library.add(faFacebookSquare);
library.add(faTwitter);
library.add(faInstagram);
library.add(faYoutube);
library.add(faSoundcloud);

Vue.component("fa-icon", FontAwesomeIcon);

export default {
  name: "Header",
  data() {
    return {
      hashtags: {},
      keyword: "",
      collapsed: true
    };
  },
  computed: {
    menus() {
      return this.$store.state.menu;
    }
  },
  mounted() {
    this.hashtags = window.init.hashtags;
  },
  methods: {
    searchit() {
      if (this.keyword !== "") {
        this.$router.push("/search/" + this.keyword);
        this.keyword = "";
      }
    }
  }
};
</script>
